import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=e5555d32&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "@/assets/help/help.css?vue&type=style&index=0&id=e5555d32&prod&scoped=true&lang=css&external"
import style1 from "./Faq.vue?vue&type=style&index=1&id=e5555d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5555d32",
  null
  
)

export default component.exports